const dashboard = {
  // Admin Dashboard
  adminDashboard: 'Admin Dashboard',
  adminSubtitle: 'Special School management and oversight',
  therapistDashboard: 'Therapist Dashboard',
  therapistSubtitle: 'Caseload, sessions, and progress tracking',
  teacherDashboard: 'Teacher Dashboard',
  teacherSubtitle: 'Class management, lessons, and student tracking',
  // Greeting banner
  pendingApprovals: 'pending approvals',
  newEnrolments: 'new enrolments',
  attendanceRecorded: 'Attendance recorded for today — all features unlocked.',
  // Admin action buttons
  reviewApprovals: 'Review Approvals',
  reports: 'Reports',
  // Therapist action buttons
  newSessionNote: 'New Session Note',
  startAssessment: 'Start Assessment',
  // Teacher action buttons
  newLessonPlan: 'New Lesson Plan',
  markAttendance: 'Mark Attendance',
  // Check-in widget
  checkInTitle: 'Ready to start your day?',
  checkInDescription: 'Check in to record your attendance and unlock full system access.',
  capturingLocation: 'Capturing your location...',
  checkInNow: 'Check In Now',
  checkingIn: 'Checking in…',
  checkedInTitle: "You're checked in!",
  checkedInAt: 'Checked in at',
  dontForget: "Don't forget to check out when you leave.",
  checkOut: 'Check Out',
  dayComplete: 'Day complete!',
  checkedOutAt: 'Checked out at',
  seeYouTomorrow: 'See you tomorrow!',
  checkInToContinue: 'Check in to continue',
  checkInGateDescription: 'Please complete your daily check-in above to access the full dashboard, student records, and all system features.',
  // Activity Feed
  activityFeed: 'Activity Feed',
  livePlatformEvents: 'Live platform events',
  // Weekly Attendance
  weeklyAttendanceTrend: 'Weekly Attendance Trend',
  past7Days: 'Past 7 days',
  avgPresent: 'avg',
  presentPct: 'present',
  present: 'Present',
  absent: 'Absent',
  avgDailyPresent: 'Avg daily present:',
  viewFullAttendance: 'View full attendance',
  // Therapist: Caseload
  myCaseload: 'My Caseload',
  activeStudents: '{{count}} active students',
  goalProgress: 'Goal Progress',
  // Teacher: Students Grid
  myStudents: 'My Students',
  searchStudents: 'Search students...',
  classProgress: 'Class Progress',
  nextSession: 'Next',
  pageOf: 'Page {{current}} of {{total}}',
  prevPage: 'Previous',
  nextPage: 'Next',
  noStudentsMatch: 'No students match your search.',
  // Student activity menu
  studentMenuTitle: '{{name}} — Quick Actions',
  caseHistory: 'Case History',
  caseHistoryDesc: 'View medical & developmental background',
  assessment: 'Assessment',
  assessmentDesc: 'Conduct or review student assessments',
  goalsLessonPlan: 'Goals & Lesson Plan',
  goalsLessonPlanDesc: 'Manage IEP goals and lesson planning',
  progressReport: 'Progress Report',
  progressReportDesc: 'Generate or view progress reports',
  documents: 'Documents',
  documentsDesc: 'Uploaded files, worksheets & resources',
  parentDiary: 'Parent Diary',
  parentDiaryDesc: 'Daily communication log with parents',
  // Therapist: Progress Chart
  multiDomainProgress: 'Multi-Domain Progress',
  progressSubtitle: 'Current vs baseline assessment scores across all domains',
  // Teacher: Subject Progress
  subjectProgress: 'Subject Progress',
  subjectProgressSubtitle: 'Current vs baseline scores across all subjects',
  baseline: 'Baseline',
  current: 'Current',
  pts: 'pts',
  goal80: '80% Goal',
  // Therapist: Session Notes
  recentSessionNotes: 'Recent Session Notes',
  notesNeedFollowUp: '{{total}} notes — {{challenging}} need follow-up',
  // Teacher: Lesson Notes
  recentLessonNotes: 'Recent Lesson Notes',
  lessonNotesSubtitle: '{{total}} notes — {{challenging}} need attention',
  newNote: 'New Note',
  positive: 'Positive',
  neutral: 'Neutral',
  challenging: 'Challenging',
  markReviewed: 'Mark Reviewed',
  // Therapist: Upcoming Sessions
  todaysSchedule: "Today's Schedule",
  sessionsCount: '{{count}} sessions',
  noSessionsToday: 'No sessions today',
  // Teacher: Upcoming Lessons
  todaysLessons: "Today's Lessons",
  lessonsCount: '{{count}} lessons',
  noLessonsToday: 'No lessons today',
  // Faculty Management
  facultyManagement: 'Faculty Management',
  facultySubtitle: 'Manage teachers, therapists, and support staff',
  activeFaculty: 'Active Faculty',
  onLeave: 'On Leave',
  addTeacher: 'Add Teacher',
  noTeachersFound: 'No teachers found',
  // Metric card labels
  totalStudents: 'Total Students',
  activeTherapists: 'Active Therapists',
  sessionsThisWeek: 'Sessions This Week',
  pendingFollowUps: 'Pending Follow-Ups',
  totalSessions: 'Total Sessions',
  totalLessons: 'Total Lessons',
  orgLessonPlans: 'Lesson Plans',
  pendingNotes: 'Pending Notes',
  avgAttendance: 'Avg Attendance',
  avgProgress: 'Avg Progress',
  goalsAchieved: 'Goals Achieved',
  // Sidebar nav items
  caseload: 'Caseload',
  studentsAttendance: 'Students Attendance',
  staffAttendance: 'Staff Attendance',
  sessions: 'Sessions',
  assessments: 'Assessments',
  progress: 'Progress',
  approvals: 'Approvals',
  reports: 'Reports',
  myChild: 'My Child',
  appointments: 'Appointments',
  resources: 'Resources',
  accessControl: 'Access Control',
  facultyManagement: 'Faculty Management',
  // Incident tracking
  unresolvedIncidentsTitle: '{{count}} unresolved incident(s) need attention',
  unresolvedIncidentsDesc: '{{unresolved}} of {{total}} total incidents require follow-up. Review and take action.',
  reviewIncidents: 'Review Incidents',
  incidentsTracked: 'Incidents Tracked',
  unresolvedCount: '{{count}} unresolved',
  allResolved: 'All resolved',
  // Announcements
  announcements: 'Announcements',
  announcementsSubtitle: 'Broadcast messages to faculty and parents',
  createAnnouncement: 'Create Announcement',
  newAnnouncement: 'New Announcement',
  publishAnnouncement: 'Publish Announcement',
  publishing: 'Publishing...',
  announcementMessage: 'Announcement Message',
  messagePlaceholder: 'Type your announcement message here...',
  recordAudio: 'Record Audio',
  stopRecording: 'Stop Recording',
  recordingAudio: 'Recording...',
  audioRecorded: 'Audio message recorded',
  selectFaculty: 'Select Faculty',
  selectParents: 'Select Parents',
  selectAll: 'Select All',
  unselectAll: 'Unselect All',
  selectedCount: '{{count}} selected',
  scheduleFor: 'Schedule For',
  publishNow: 'Publish Now',
  scheduleLater: 'Schedule Later',
  noAnnouncements: 'No announcements yet',
  noAnnouncementsDesc: 'Announcements you create will appear here.',
  searchAnnouncements: 'Search announcements...',
  allAnnouncements: 'All Announcements',
  filterByDate: 'Filter by date',
  sentTo: 'Sent to',
  allFaculty: 'All Faculty',
  allParents: 'All Parents',
  selectedFaculty: '{{count}} Faculty',
  selectedParents: '{{count}} Parents',
  noRecipients: 'No recipients selected',
  publishedBy: 'Published by',
  scheduled: 'Scheduled',
  published: 'Published',
  onDate: 'on',
  announcementCreated: 'Announcement published successfully!',
  announcementScheduled: 'Announcement scheduled successfully!',
  messageRequired: 'Message is required',
  recipientsRequired: 'Please select at least one recipient group',
  facultyAndParents: 'Faculty & Parents',
  facultyOnly: 'Faculty Only',
  parentsOnly: 'Parents Only',
  audioMessageAttached: 'Audio message attached',
  deleteAnnouncement: 'Delete Announcement',
  deleteAnnouncementConfirm: 'Are you sure you want to delete this announcement?',
  announcementDeleted: 'Announcement deleted',
  clearDateFilter: 'Clear date filter',
  todayAnnouncements: "Today's Announcements",
  upcomingAnnouncements: 'Upcoming Announcements',
  previousAnnouncements: 'Previous Announcements',
  noTodayAnnouncements: 'No announcements published today',
  noTodayAnnouncementsDesc: 'Announcements published today will show up here.',
  noUpcomingAnnouncements: 'No upcoming announcements scheduled',
  noUpcomingAnnouncementsDesc: 'Scheduled announcements for future dates will appear in this tab.',
  noPreviousAnnouncements: 'No previous announcements',
  noPreviousAnnouncementsDesc: 'Past announcements will appear here after the publish date has passed.',
  byLabel: 'by',
  audioAnnouncement: 'Audio Announcement',
  playAudio: 'Play Audio',
  pauseAudio: 'Pause Audio',
  selectedRecipients: 'Selected Recipients',
  noFacultySelected: 'No faculty selected',
  noParentsSelected: 'No parents selected',
  scheduleDateTime: 'Schedule Date & Time',
  // Read status
  markAsRead: 'Mark as Read',
  read: 'Read',
  unread: 'Unread',
  // School Calendar
  schoolCalendar: 'School Calendar',
  schoolCalendarSubtitle: 'Unified calendar — events, holidays & tasks',
  calendarView: 'Calendar View',
  listView: 'List View',
  goToToday: 'Today',
  previousMonth: 'Previous Month',
  nextMonth: 'Next Month',
  selectDate: 'Select Date',
  globalEvents: 'Global Awareness Days',
  schoolHolidays: 'School Holidays',
  personalTasks: 'My Tasks',
  showGlobalEvents: 'Show Global Events',
  showSchoolHolidays: 'Show School Holidays',
  showPersonalTasks: 'Show My Tasks',
  addTask: 'Add Task',
  addNewTask: 'Add New Task',
  taskTitle: 'Task Title',
  taskTitlePlaceholder: 'Enter task title...',
  dueTime: 'Due Time',
  taskDescription: 'Description',
  taskDescriptionPlaceholder: 'Add a brief description...',
  taskCreated: 'Task created successfully!',
  taskUpdated: 'Task updated successfully!',
  taskCompleted: 'Task marked as completed',
  deleteTask: 'Delete Task',
  deleteTaskConfirm: 'Are you sure you want to delete this task?',
  noTasksForDate: 'No tasks for this date',
  noEventsFound: 'No events found',
  allDay: 'All Day',
  markComplete: 'Mark Complete',
  markIncomplete: 'Mark Incomplete',
  recurring: 'Recurring annually',
  holidayNational: 'National',
  holidayRegional: 'Regional',
  holidayDiscretionary: 'Discretionary',
  impactsAttendance: 'Impacts Attendance',
  targetAll: 'All',
  targetTeachers: 'Teachers',
  targetParents: 'Parents',
  // Calendar Settings
  calendarSettings: 'Calendar Settings',
  calendarSettingsSubtitle: 'Manage global awareness days and school holidays',
  awarenessEventsMaster: 'Awareness Events Master',
  holidayMaster: 'Holiday Master',
  awarenessEventsDescription: 'Define and manage global awareness days observed across the school network.',
  holidayMasterDescription: 'Manage school holidays that impact scheduling and attendance calculations.',
  addEvent: 'Add Event',
  addHoliday: 'Add Holiday',
  editEvent: 'Edit Event',
  editHoliday: 'Edit Holiday',
  eventName: 'Event Name',
  eventDate: 'Event Date (DD/MM)',
  isRecurring: 'Recurring Annually',
  targetAudience: 'Target Audience',
  eventDescription: 'Description',
  holidayTitle: 'Holiday Title',
  startDate: 'Start Date',
  endDate: 'End Date',
  holidayType: 'Holiday Type',
  impactsAttendanceLabel: 'Impacts Attendance Calculation',
  importCsv: 'Import CSV',
  csvImportHint: 'Upload a CSV file with columns: Event Name, Date (DD/MM), Is Recurring, Target Audience, Description',
  noEventsDefined: 'No awareness events defined yet.',
  noHolidaysDefined: 'No holidays defined yet.',
  eventCreated: 'Event created successfully!',
  holidayCreated: 'Holiday created successfully!',
  eventUpdated: 'Event updated successfully!',
  holidayUpdated: 'Holiday updated successfully!',
  eventDeleted: 'Event deleted successfully!',
  holidayDeleted: 'Holiday deleted successfully!',
  duplicateDateRange: 'This date range overlaps with an existing holiday',
  noTasksForDay: 'No tasks for this day',
  completedTasks: 'Completed',
  pendingTasks: 'Pending',
};

export default dashboard;